import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { donorapi } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});


export const fetchData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid:uid };
            const apiname = donorapi.donation;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

